import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Plateform() {
  return (
    <section className="nurs_idea p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center my-auto order-md-1 order-2"
          >
            <div className="solution_img">
              <StaticImage
                src="../../../images/case-studies/nurse-practition/tek_img_03.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={570}
                height={712}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={7}
            lg={7}
            xl={6}
            xxl={6}
            className="offset-xl-1 my-auto order-md-2 order-1"
          >
            <h2>
              Platform
              <span style={{ color: "#6D4FC1" }}> Features</span>
            </h2>
            <p>
              The Nurse Practitioners application has multiple useful features
              for all users. From quick and handy ones to other beneficial
              features, we made sure to add them to the app.
            </p>
            <ul className="ul_style nurs_style">
              <li>
                <strong>Search The Nurse</strong>
                <p>
                  The users in need of nursing or medical care can easily search
                  for nurses through the application, where all their
                  information is shown along with other necessary details.
                </p>
              </li>
              <li>
                <strong>Request Visit</strong>
                <p>
                  Users, upon finalizing their nurse of choice, can request a
                  home visit of the nurse in specific hours or a limited period
                  of time through the application hassle-free.
                </p>
              </li>
              <li>
                <strong>Consult Via Video Call</strong>
                <p>
                  In case there is no need for a visit but the need for
                  assistance, nurses, can also consult the patient through a
                  live video call and listen to and resolve their queries as
                  well as guide them.
                </p>
              </li>
              <li>
                <strong>Tracking & Acknowledgement</strong>
                <p>
                  All the requests, visits, calls, and correspondence is tracked
                  and acknowledged within the applications for the user’s
                  convenience, and they can be accessed anytime.
                </p>
              </li>
              <li>
                <strong>Wage Processing</strong>
                <p>
                  For nurses, the wage can be processed through the app based on
                  the services provided or hours worked. Taxation and relevant
                  matters can also be managed through it.
                </p>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Plateform;
